import Typography, { TypographyProps } from '@mui/material/Typography';
import Paper, { PaperProps } from '@mui/material/Paper';
import TableCell, { TableCellProps } from '@mui/material/TableCell';
import { styled } from '@mui/system';


export const StyledContainer= styled(Paper)<PaperProps>(({ theme }) => ({
    marginTop: theme.spacing(5),
    border: "1px solid lightblue",
    padding: theme.spacing(1),
    backgroundColor: "#f7f8fd"
}));

export const StyledCell = styled(TableCell)<TableCellProps>(({ theme }) => ({
    fontWeight: "bold",
}));

export const Title = styled(Typography)<TypographyProps>(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: "red",
    textAlign: "left",
    fontWeight: "bold"
}));
